<div class="container">
    <div class="title-wrapper">
        <div class="title">
            {{ 'mimics.settings.range-indicator.title' | translate }}
        </div>
    </div>

    <div class="ranges-container" *ngIf="rangesArray?.length > 0 && colorList.length !== 0">
        <div *ngFor="let coloredRange of colorList; index as index">
            <app-range-color-indicator
                [colorId]="coloredRange.colorId"
                [color]="coloredRange.color"
                [min]="coloredRange.min"
                [max]="coloredRange.max"
                [enabled]="userCanEdit && coloredRange.enabled"
                [minRange]="assignedChannel.fcuData.measurableRange?.min"
                [maxRange]="assignedChannel.fcuData.measurableRange?.max"
                [foreignObject]="foreignObject"
                (onRangeChange)="handleRangeChanged($event, index)"
                (onRangeDelete)="deleteRange(index)"></app-range-color-indicator>
        </div>
    </div>
    <div class="create-range-button">
        <app-button
            class="new-button"
            text="mimics.settings.range-indicator.add"
            customFontSize="12px"
            [disable]="!userCanEdit"
            (onClick)="createRange()"></app-button>
    </div>
</div>
